import {
    FaAngleUp,
    FaAngleDown
} from 'react-icons/fa';

import {
    ColumnContainer,
    Subtitle,
    Table,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableRow
} from '../../../../styles/component.styles';

const FulfillmentsTable = ({
    fulfillments = [],
    sortKey = '',
    setSortKey = () => {},
    sortDirection = '',
    setSortDirection = () => {},
    navigateToFulfillment = () => {}
}) => {

    const sortColumn = (key) => {
        if (key === sortKey) {
            if (sortDirection === 'ASC') {
                setSortDirection('DESC');
            } else if (sortDirection === 'DESC') {
                setSortDirection('');
                setSortKey('');
            } else {
                setSortDirection('ASC');
            }
        } else {
            setSortKey(key);
            setSortDirection('ASC');
        }
    };

    return (
        <ColumnContainer>
            {fulfillments.length === 0 ?
                <Subtitle>No Fulfillments To Display</Subtitle>
            :
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead cursor={'pointer'} onClick={() => sortColumn('status')}>
                                <ColumnContainer flexDirection={'row'}>
                                    Status
                                    {sortKey === 'status' && sortDirection === 'ASC' ?
                                        <FaAngleUp />
                                        : sortKey === 'status' && sortDirection === 'DESC' ?
                                            <FaAngleDown />
                                            : <ColumnContainer minHeight={'1em'} minWidth={'1em'} />
                                    }
                                </ColumnContainer>
                            </TableHead>
                            <TableHead>
                                <ColumnContainer flexDirection={'row'}>
                                    Tracking #
                                    <ColumnContainer minHeight={'1em'} minWidth={'1em'} />
                                </ColumnContainer>
                            </TableHead>
                            <TableHead cursor={'pointer'} onClick={() => sortColumn('createdAt')}>
                                <ColumnContainer flexDirection={'row'}>
                                    Date
                                    {sortKey === 'createdAt' && sortDirection === 'ASC' ?
                                        <FaAngleUp />
                                        : sortKey === 'createdAt' && sortDirection === 'DESC' ?
                                            <FaAngleDown />
                                            : <ColumnContainer minHeight={'1em'} minWidth={'1em'} />
                                    }
                                </ColumnContainer>
                            </TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {fulfillments.map((fulfillment, index) => {
                            const formattedDate = new Date(fulfillment.createdAt).toLocaleDateString('en-us', { day: 'numeric', year: 'numeric', month: 'numeric' });
                            return (
                                <TableRow key={index} onClick={() => navigateToFulfillment(fulfillment.id)} cursor={'pointer'}>
                                    <TableData>{fulfillment.status}</TableData>
                                    <TableData>{fulfillment.trackingNumber || '—'}</TableData>
                                    <TableData>{formattedDate}</TableData>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            }
        </ColumnContainer>
    );
};

export default FulfillmentsTable;
